import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import get from 'lodash/get';
import classNames from 'classnames';

import PageContainer from 'shared-components/PageContainer/PageContainer';
import Button from 'shared-components/Button/Button';
import styles from './ClosedSocialBanner.module.css';

const ClosedSocialBanner = ({
  campaignStartDate,
  copyType,
  buttonAction,
  buttonText,
}) => {
  const date = moment(campaignStartDate).tz('America/Los_Angeles');
  const amPm = Number(date.format('H')) > 12 ? 'p.m.' : 'a.m.';
  const startDate = date.format('MMMM D [at] h');
  const bannerCopy = {
    invite: {
      title: 'Get Ready to Shop with Friends',
      message:
        'Send invites to your friends. You’ll be able to shop together and get access to exclusive products at incredible discounts!',
      footer: `Your access starts on ${startDate} ${amPm} PT.`,
    },
    upgrade: {
      title: 'Shop With Friends Now',
      message: (
        <>
          Join in on the fun! You’ll be able to shop together and get access to
          exclusive products at incredible discounts.
          <br />
          <br />
          <span>
            Upgrade to get access on{' '}
            <strong>
              {startDate} {amPm} PT.
            </strong>
          </span>
        </>
      ),
    },
    reactivate: {
      title: 'Shop With Friends Now',
      message: (
        <>
          Join in on the fun! You’ll be able to shop together and get access to
          exclusive products at incredible discounts.
          <br />
          <br />
          <span>
            Reactivate to get access on{' '}
            <strong>
              {startDate} {amPm} PT.
            </strong>
          </span>
        </>
      ),
    },
    checkMyAccount: {
      title: 'Get Ready to Shop with Friends',
      message: (
        <>
          Send invites to your friends. You’ll be able to shop together and get
          access to exclusive products at incredible discounts!
        </>
      ),
      footer: 'Review your billing information to access the sale.',
    },
  };
  const copy = get(bannerCopy, copyType, {});

  return (
    <div className={styles.container}>
      <PageContainer>
        <div className={classNames(styles.content, styles[copyType])}>
          <h1>{copy.title}</h1>
          <p className={styles.message}>{copy.message}</p>
          <Button className={styles.button} onClick={buttonAction}>
            {buttonText}
          </Button>
          {copy.footer && <p className={styles.access}>{copy.footer}</p>}
        </div>
      </PageContainer>
    </div>
  );
};

ClosedSocialBanner.propTypes = {
  campaignStartDate: PropTypes.string.isRequired,
  copyType: PropTypes.string.isRequired,
  buttonAction: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default ClosedSocialBanner;
